import PropTypes from 'prop-types';


// ------ shapes
export const SHAPE_PHONE = PropTypes.shape({
    callingCode: PropTypes.number,
    countryAlpha2: PropTypes.string,
    number: PropTypes.string
});
